import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "roles";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const stripRoleIds = (role = {}) => {
  const { id, id_doc, idDoc, ...payload } = role;
  return payload;
};

const RolesService = {
  getRoles: async () =>
    apiService.get(ENDPOINT, {
      params: currentUserPayload(),
    }),

  createRole: async (role, featureIds = []) =>
    apiService.post(ENDPOINT, {
      ...currentUserPayload(),
      role: stripRoleIds(role),
      featureIds,
    }),

  editRole: async (id, role, featureIds) =>
    apiService.put(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      ...currentUserPayload(),
      role: stripRoleIds(role),
      featureIds,
    }),

  deleteRole: async (id) =>
    apiService.delete(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      data: currentUserPayload(),
    }),

  getRoleFeaturesByIdRole: async (id) =>
    apiService.get(`${ENDPOINT}/${encodeURIComponent(id)}/features`, {
      params: currentUserPayload(),
    }),

  getUsersByIdRole: async (id) =>
    apiService.get(`${ENDPOINT}/${encodeURIComponent(id)}/users`, {
      params: currentUserPayload(),
    }),
};

export default RolesService;
